import { ArrowBackIos, ArrowLeft, FileCopy, ForkLeft, VolumeUp } from '@mui/icons-material';
import { Box, Chip, CircularProgress, Divider, IconButton, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AudioDetails from './Modals/AudioDetails';
import Axios from '../../../../../axios/Axios';
import dayjs from 'dayjs';
import { SessionDetails } from './Modals/SessionDetails';
import axios from 'axios';


function StudentLevelDetails() {

  const navigate = useNavigate();
  const { state: studentId, location } = useLocation();

  const [openAudioModal, setOpenAudioModal] = useState(false);
  const [ requestDataForAudioModal, setRequestDataForAudioModal ] = useState({
    studentId: null,
    levelId: null,
    levelName: null,
    teacherId:null,
  });
  const[levelData, setLevelData] = useState()
  const [openSectionDetailsModal, setOpenSectionDetailsModal] = useState(false);
  
const [requestDataForSectionDetailsModal, setRequestDataForSectionDetailsModal] = useState({
    studentId:null,
    teacherId:null,
    levelId:null,
})
  const [ levelDetailsData, setLevelDetailsData ] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: [],
    error: null
  });

  const [reloadPage, setReloadPage] = useState(false);

  const handlePageReload = () => {
    setReloadPage(!reloadPage)
  }

  useEffect(() => {
 const controller = axios.CancelToken.source()
    if(!!studentId){
        // console.log(studentId);
        (async () => {
            try{
                setLevelDetailsData(prev => ({...prev, isLoading: true, isSuccess: false, isError: false, data: [], error: null}))
                let options = {
                    method: "GET",
                    url: `student/leveldetails/for/spoc/${studentId}`,
                    auth: true,
                    data: null,
                    token:{cancelToken: controller.token}
                };
        
                const response = await Axios(
                    options.method,
                    options.url,
                    options.auth,
                    options.data,
                    options.token,
                );
            //   console.log(response);
                if(response.status === 200){
                    response.data.sort((a, b) => a.level_id - b.level_id)
                    setLevelDetailsData(prev => ({...prev, isSuccess: true, data: response.data}));
                }
            }catch(error){
                if(!axios.isCancel(error)){
                    setLevelDetailsData(prev => ({...prev, isError: true, error: error.data}))
                    console.log(error);
                }
            }
        })()
    }

    return () => {
            controller.cancel();
        }
  }, [studentId, reloadPage]);


  let content;

// console.log(levelData);
  if(levelDetailsData.isLoading){
    content = (<Box sx={{p: 5, margin: "0 auto"}}>
        <CircularProgress/>
    </Box>)
  }

  if(levelDetailsData.isError){
    content = (<Box sx={{p: 5, margin: "0 auto"}}>
        <p>{levelDetailsData.error}</p>
    </Box>)
  }

  if(levelDetailsData.isSuccess){
    content = levelDetailsData.data?.map((leveldata, i) =>{ 
        return(
        <StudentLevelDetailsRow 
            key={i} 
            
            data={leveldata}
            setRequestDataForAudioModal={setRequestDataForAudioModal}
            setOpenAudioModal={setOpenAudioModal}
      setOpenSectionDetailsModal={(value) => setOpenSectionDetailsModal(value)}
      setRequestDataForSectionDetailsModal={setRequestDataForSectionDetailsModal}
        />
    )})
  }

  const handleClick = () => {
    const currentPath = window.location.hash;
    if (currentPath === '#/spoc/student-level-details') {
      navigate('/spoc/mapped');
    } else if (currentPath === '#/student-level-details') {
      navigate('/lte-session-student');
    }
  };

  return (
    <>
    <Stack
        sx={{
            minHeight: "100vh",
            px: 5,
            py: 3
        }}
    >
        <Stack direction="row" alignItems="center">
            <IconButton onClick={handleClick} sx={{ color: "black"}}>
                <ArrowBackIos></ArrowBackIos>
            </IconButton>
            <Typography sx={{fontWeight: "bold"}} variant='h5'>LEVEL DETAILS</Typography>
        </Stack>
        {content}
    </Stack>
    <AudioDetails 
        openAudioModal={openAudioModal} 
        setOpenAudioModal={setOpenAudioModal}
        requestData={requestDataForAudioModal}
        pageReload ={handlePageReload}
    ></AudioDetails>
    <SessionDetails
      openSectionDetailsModal={openSectionDetailsModal}
      setOpenSectionDetailsModal={setOpenSectionDetailsModal}
      levelData={levelData}
      requestDataForSectionDetailsModal={requestDataForSectionDetailsModal}
    >

    </SessionDetails>
    </>
  )
}

export default StudentLevelDetails

function StudentLevelDetailsRow({data, setOpenAudioModal, setRequestDataForAudioModal, setOpenSectionDetailsModal, setRequestDataForSectionDetailsModal}){

    let colors = [ "primary", "secondary", "info", "success" ];
    // setLevelData(data)
    // console.log(colors[Math.floor(Math.random() * colors.length)]);
    // console.log(data);
    return(
        <>
        <Stack pt={2} px={2}>
            <Stack direction="row" justifyContent="space-between">
                <Stack 
                width="5%" 
                // spacing={1}
                >
                    <Stack direction="column" alignItems="flex-start" spacing={1}>
                        <Typography fontWeight="bold" variant='h6'>
                            {data.level_name}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                        <Chip label={data.teacher_name ? data.teacher_name : "Level not assigned"}  
                        // color={data.teacher_name ? colors[Math.floor(Math.random() * colors.length)] : "default"}  
                        style={{
                            color: data.teacher_name ? 'white' : 'black',
                            backgroundColor: data.teacher_name ? '#0288d1' : 'default'}}
                        size='small'/>
                        {data.level_status === "completed" ? <Chip  label = {data.level_status} color="success"   /> : ""}
                        </Stack>
                        
                        
                    </Stack>
                    {/* <Stack>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis assumenda dolorum sint? Fugit atque earum accusamus beatae quasi, explicabo temporibus, omnis ipsam pariatur, architecto eos! Deleniti laboriosam expedita cupiditate dolorum!</p>
                    </Stack> */}
                </Stack>
                <Stack spacing={2} py={2} textAlign="center">
                    <Typography fontWeight="bold" variant='subtitle1' color="GrayText">
                        Completed sessions
                    </Typography>
                    <Typography variant='h5' color="GrayText">{data.completed_sessions}</Typography>
                </Stack>

                <Stack spacing={2} py={2} textAlign="center">
                    <Typography fontWeight="bold" variant='subtitle1' color="GrayText">
                        Incomplete sessions
                    </Typography>
                    <Typography variant='h5' color="GrayText">{data.incomplete_sessions}</Typography>
                </Stack>

                {/* <Stack spacing={2} py={2} textAlign="center">
                    <Typography fontWeight="bold" variant='subtitle1' color="GrayText">
                        Level start & End date
                    </Typography>
                    <Typography variant='subtitle1' color="GrayText">{(data.start_data || data.end_date) ? `${dayjs(data.start_date).format("DD/MM/YYYY")} - ${dayjs(data.end_date).format("DD/MM/YYYY")}` : "none"}</Typography>
                </Stack> */}

                <Stack spacing={2} py={2} textAlign="center">
                    <Typography fontWeight="bold" variant='subtitle1' color="GrayText">
                        Audio file
                    </Typography>
                    <Box>
                        <IconButton 
                            // disabled={!data.teacher_name} 
                            onClick={() => {
                                setRequestDataForAudioModal({
                                    studentId: data.stud_id,
                                    levelId: data.level_id,
                                    levelName: data.level_name,
                                    teacherId:data.teacher_id,
                                })
                                setOpenAudioModal(true);
                            }} 
                            sx={ data.audio_status=== "approved" ?{color: "#66BB6A"} : data.audio_status=== "not approved" ?{color:"#d500f9"}:  {color: "#1d3faa"}}
                            >
                            <VolumeUp></VolumeUp>
                        </IconButton>
                    </Box>
                </Stack>

                <Stack spacing={2} py={2} textAlign="center">
                    <Typography fontWeight="bold" variant='subtitle1' color="GrayText">
                        Session details
                    </Typography>
                    <Box>
                        <IconButton 
                        // disabled={!data.teacher_name} 
                        sx={{ color: "#1d3faa"}}
                        onClick={()=>{
                            
                            setRequestDataForSectionDetailsModal({
                               teacherId: data.teacher_id,
                               studentId: data.stud_id,
                               levelId: data.level_id,
                            })
                            setOpenSectionDetailsModal(true)  
                        }}
                        >
                            <FileCopy></FileCopy>
                        </IconButton>
                    </Box>
                </Stack>
            </Stack>
        </Stack>
        <Divider></Divider>
        </>
    )
}